import { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { setRecoil } from "recoil-nexus";
import LogController from "../../../../controller/LogController";
import { EventType } from "../../../../controller/MasterController";
import { adverState } from "../../../../recoil/adver";
import { eventState } from "../../../../recoil/event";
import { langState } from "../../../../recoil/lang";
import { EventContentProps } from "./type";

// 광고,이벤트 종료 후 재발생 시간
const restTime = 60 * 1000 * 20;
let inactiveTimer: any;

export const useEventContent = (props: EventContentProps) => {
  const lang = useRecoilValue(langState);

  const timeRecommendListEnabled =
    props.timeSectorRecommend &&
    props.timeSectorRecommend.background_image_url &&
    props.timeSectorRecommend.store_data.length > 2
      ? 1
      : 0;

  const [adverFlag, setAdverFlag] = useRecoilState<boolean>(adverState);

  const [slideIndex, setSlideIndex] = useState<number>(0);
  const sliderRef = useRef<any>(null);
  const timerRef = useRef<any>(null);

  // 룰렛이벤트 바로가기
  const handleGoRouletteEvent = () => {
    if (sliderRef.current) {
      setSlideIndex(0);
      sliderRef.current.style.transform = `translateX(-${slideIndex * 100}%)`;
    }
  };

  // 슬라이더 이동 로직
  const slideHandler = (direction: number) => {
    if (props.eventList && props.adverList) {
      setSlideIndex((prev) => {
        let nextIndex = prev + direction;
        if (nextIndex < 0) {
          nextIndex =
            props.eventList!.length +
            props.adverList!.length +
            timeRecommendListEnabled -
            1;
        } else if (
          nextIndex >=
          props.eventList!.length +
            props.adverList!.length +
            timeRecommendListEnabled
        ) {
          nextIndex = 0;
        }
        return nextIndex;
      });
    }
  };

  // 비디오 종료되었을 때 슬라이더 이동 로직
  const handleVideoEnd = (index: number) => {
    if (props.eventList && props.adverList) {
      const video = document.getElementById(
        `adVideo${index}`
      ) as HTMLVideoElement | null;
      if (video && !video.ended) return;

      // event가 끝나는 시점부터 (광고 시점) 시작
      if (
        index ===
        slideIndex - props.eventList!.length - timeRecommendListEnabled
      ) {
        setSlideIndex(
          (prev) =>
            (prev + 1) %
            (props.eventList!.length +
              props.adverList!.length +
              timeRecommendListEnabled)
        );
      }
    }
  };

  // 이벤트에 해당되는 페이지 이동
  const openEvent = (eventData: EventType) => {
    resetPage();
    setRecoil(eventState, {
      ...eventData,
      visible: true,
      coupon: null,
    });
    LogController.click({
      path: "AdverContent",
      params: "event",
      params2: `${eventData.event_name} 광고 클릭`,
      index: eventData.event_id,
    });
  };

  // 광고 클릭 로그
  const adverClick = (storeId: number, storeName: string) => {
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "adver",
      params2: storeName,
      store_id: storeId,
      index: storeId,
    });
  };

  // 광고,이벤트 시작
  const resetPage = () => {
    clearTimeout(inactiveTimer);
    inactiveTimer = null;
    startTimer();
    setAdverFlag(false);
  };

  const startTimer = () => {
    inactiveTimer = setTimeout(() => {
      setSlideIndex(0);
    }, restTime);
  };

  // API 호출, 광고 노출 타이머 작동 (20분)
  useEffect(() => {
    startTimer();

    clearTimeout(inactiveTimer);
    inactiveTimer = null;
  }, []);

  // 비디오가 아닌 이벤트는 3초마다 자동으로 이동
  useEffect(() => {
    if (
      (props.eventList?.length ?? 0) +
        (props.adverList?.length ?? 0) +
        timeRecommendListEnabled <=
      0
    ) {
      setAdverFlag(false);
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    if (props.eventList && props.adverList) {
      const adverIndex =
        slideIndex - props.eventList.length - timeRecommendListEnabled;
      const adverItem = props.adverList[adverIndex];

      const isVideo = adverItem?.mime_type?.includes("video") ?? false;

      if (!isVideo) {
        timerRef.current = setTimeout(() => {
          setSlideIndex(
            (prev) =>
              (prev + 1) %
              (props.eventList!.length +
                props.adverList!.length +
                timeRecommendListEnabled)
          );
        }, 3000);
      }
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [slideIndex, props.eventList, props.adverList, timeRecommendListEnabled]);

  return {
    lang,
    timeRecommendListEnabled,
    slideIndex,
    sliderRef,
    adverFlag,
    handleGoRouletteEvent,
    slideHandler,
    handleVideoEnd,
    openEvent,
    resetPage,
    adverClick,
  };
};
